define("shared/components/shared/expandable-truncated-text", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "tracked-built-ins", "@ember/template-factory"], function (_exports, _component, _object, _component2, _trackedBuiltIns, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"tracked-built-ins",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <p ...attributes>
    {{this.textToDisplay}}
    {{#if this.hasCaptionExceedingMaximum}}
      <Shared::Ui::Button
        @onClick={{this.toggleCollapsedText}}
        @variant="actionLink"
        data-test-id="toggle-expand-button"
        type="button"
      >
        {{t (if this.isTextCollapsed "shared_phrases.show_more" "shared_phrases.show_less")}}
      </Shared::Ui::Button>
    {{/if}}
  </p>
  */
  {
    "id": "XEC11uuH",
    "block": "[[[11,2],[17,1],[12],[1,\"\\n  \"],[1,[30,0,[\"textToDisplay\"]]],[1,\"\\n\"],[41,[30,0,[\"hasCaptionExceedingMaximum\"]],[[[1,\"    \"],[8,[39,1],[[24,\"data-test-id\",\"toggle-expand-button\"],[24,4,\"button\"]],[[\"@onClick\",\"@variant\"],[[30,0,[\"toggleCollapsedText\"]],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[[52,[30,0,[\"isTextCollapsed\"]],\"shared_phrases.show_more\",\"shared_phrases.show_less\"]],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\"],false,[\"if\",\"shared/ui/button\",\"t\"]]",
    "moduleName": "shared/components/shared/expandable-truncated-text.hbs",
    "isStrictMode": false
  });
  let ExpandableTruncatedTextComponent = _exports.default = (_class = class ExpandableTruncatedTextComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "isTextCollapsed", _descriptor, this);
      if (this.args.shouldStartExpanded) {
        this.isTextCollapsed = false;
      }
    }
    get hasCaptionExceedingMaximum() {
      return this.args.text.length > this.args.maximumLength;
    }
    get shouldDisplayTruncated() {
      return this.hasCaptionExceedingMaximum && this.isTextCollapsed;
    }
    get textToDisplay() {
      return this.shouldDisplayTruncated ? this.truncatedText : this.args.text;
    }
    get truncatedText() {
      return `${this.args.text?.substring(0, this.args.maximumLength)}...`;
    }
    toggleCollapsedText(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isTextCollapsed = !this.isTextCollapsed;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isTextCollapsed", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleCollapsedText", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCollapsedText"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ExpandableTruncatedTextComponent);
});